module.exports = __webpack_public_path__ + "img/horizontal-bg-zh.c5b64f56.png";